<template>
  <div>
    <div class="row">
      <div v-if="loading" id="loader"></div>
      <div v-else class="col-12 mt-0">
        <b-card no-body class="mb-0" style="width: 470px !important">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <p class="button1">3. Respuesta</p>
          </b-card-header>
          <b-card-body>
            <form @submit="saveResponse" onsubmit="return false">
              <div class="row">
                <div class="col-3 text-right">
                  <p class="p1"><b>Tipo</b></p>
                </div>
                <div class="col-9 text-left">
                  <div class="form-group">
                    <b-form-select
                      @change="validateDraft"
                      v-model="type"
                      required
                      size="lg"
                      class="mt-0"
                    >
                      <b-form-select-option
                        value="borrador"
                        :disabled="canEdit ? '' : disabled"
                        >Borrador</b-form-select-option
                      >
                      <b-form-select-option
                        value="provisional"
                        :disabled="canEdit ? '' : disabled"
                        >Provisional</b-form-select-option
                      >
                      <b-form-select-option
                        value="final"
                        :disabled="finalAnswer || canEdit ? '' : disabled"
                        >Final</b-form-select-option
                      >
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-right">
                  <p class="p1"><b>Mensaje</b></p>
                </div>
                <div class="col-9 text-left">
                  <div class="form-group">
                    <textarea
                      class="form-control"
                      id="textarea1"
                      v-model="body"
                      rows="2"
                      placeholder="Escribe el mensaje que acompañará la respuesta al derecho de petición..."
                      :required="typeValidate"
                      :disabled="canEdit ? '' : disabled"
                    >
                    </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-right">
                  <p class="p1"><b>Sociedad</b></p>
                </div>
                <div class="col-9 text-left">
                  <div class="form-group">
                    <b-form-select
                      v-model="society"
                      :options="opcionSocieties"
                      size="lg"
                      class="mt-0"
                      @change="setImages"
                      :required="typeValidate"
                      :disabled="canEdit ? '' : disabled"
                    >
                    </b-form-select>
                  </div>
                </div>
              </div>

              <!-- Tipo respuesta -->
              <div class="row">
                <div class="col-3 text-right">
                  <p class="p1"><b>Tipo envío de la respuesta</b></p>
                </div>
                <div class="col-9 text-left">
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      id="rta1Envio"
                      v-model="typeShipping"
                      name="typeShipping"
                      value="correo"
                      class="custom-control-input"
                      checked
                      @click="cleanData"
                      :required="typeValidate"
                      :disabled="canEdit ? '' : disabled"
                    />
                    <label
                      class="custom-control-label p1"
                      value="correo"
                      for="rta1Envio"
                      >Correo</label
                    >
                  </div>
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      id="rta2Envio"
                      v-model="typeShipping"
                      name="typeShipping"
                      value="fisica"
                      class="custom-control-input"
                      @click="cleanData"
                      :required="typeValidate"
                      :disabled="canEdit ? '' : disabled"
                    />
                    <label
                      class="custom-control-label p1"
                      value="fisica"
                      for="rta2Envio"
                      >Fisica</label
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-right">
                  <p class="p1" v-if="this.typeShipping != 'fisica'">
                    <b>Enviar a</b>
                  </p>
                </div>
                <div class="col-9 text-left">
                  <input
                    v-model="para"
                    type="email"
                    class="form-control"
                    :required="typeValidate"
                    :disabled="canEdit ? '' : disabled"
                    v-if="this.typeShipping != 'fisica'"
                  />
                </div>
              </div>
              <div class="row" v-if="this.typeShipping == 'fisica'">
                <div class="col-3 text-right">
                  <p class="p1"><b>Dirección</b></p>
                </div>
                <div class="col-9 text-left">
                  <input
                    v-model="addressShipping"
                    type="text"
                    class="form-control"
                    :disabled="canEdit ? '' : disabled"
                  />
                </div>
              </div>
              <div class="row" v-if="this.typeShipping == 'fisica'">
                <div class="col-3 text-right">
                  <p class="p1"><b>Guía</b></p>
                </div>
                <div class="col-9 text-left">
                  <input
                    v-model="guide"
                    type="text"
                    class="form-control"
                    :disabled="canEdit ? '' : disabled"
                  />
                </div>
              </div>
              <div class="row" v-if="this.typeShipping == 'fisica'">
                <div class="col-3 text-right">
                  <p class="p1"><b>Empresa Transportadora</b></p>
                </div>
                <div class="col-9 text-left">
                  <input
                    v-model="business"
                    type="text"
                    class="form-control"
                    :disabled="canEdit ? '' : disabled"
                  />
                </div>
              </div>
              <!--FIn Tipo respuesta -->

              <div class="row">
                <div class="col-3 text-right">
                  <p class="p1"><b>Archivos adjuntos a la respuesta</b></p>
                </div>
                <div class="col-9 text-left">
                  <table
                    class="
                      table table-bordered table-striped table-hover table-sm
                    "
                  >
                    <thead>
                      <tr class="p1">
                        <th>Archivo</th>
                        <th>Cargado por</th>
                        <th>Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in this.files.data" :key="index">
                        <a :href="serverPath + '/' + row.path" target="_blank">
                          <th>
                            <p class="p1">{{ row.name }}</p>
                          </th>
                          <th>
                            <p class="p1">{{ row.uploader.name }}</p>
                          </th>
                        </a>
                        <th align="center">
                          <input
                            type="checkbox"
                            v-model="filesAnswer"
                            :value="row.id"
                          />
                        </th>
                        <th>
                          <button
                            type="button"
                            class="btn btn-light"
                            @click="deleteFileRes(row.uploader.id, row.id)"
                          >
                            <img src="@/assets/images/icons/trash.svg" />
                          </button>
                        </th>
                      </tr>
                      <tr>
                        <td colspan="4">
                          <div class="file-upload-img">
                            <input
                              type="file"
                              id="fileDocu"
                              @change="uploadfile"
                              multiple
                            />
                            <p class="p1">+Subir archivos</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Opción con copia -->
              <div class="row mt-2 d-flex justify-content-end">
                <div v-if="user.core_role_id !== 2" class="col-3 text-right">
                  <p class="p1"><b>Con copia a Bussines partner</b></p>
                </div>
                <div v-if="user.core_role_id !== 2" class="col-6 text-left">
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      id="rta1ConCopia"
                      v-model="withCopy"
                      name="withCopy"
                      value="si"
                      class="custom-control-input"
                      checked
                      :required="typeValidate"
                      :disabled="canEdit ? '' : disabled"
                    />
                    <label
                      class="custom-control-label p1"
                      value="correo"
                      for="rta1ConCopia"
                      >si</label
                    >
                  </div>
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      type="radio"
                      id="rta2ConCopia"
                      v-model="withCopy"
                      name="withCopy"
                      value="no"
                      class="custom-control-input"
                      :required="typeValidate"
                      :disabled="canEdit ? '' : disabled"
                    />
                    <label
                      class="custom-control-label p1"
                      value="fisica"
                      for="rta2ConCopia"
                      >no</label
                    >
                  </div>
                </div>

                {{this.message}}
                <div class="col-3 text-right">
                  <b-button type="button" variant="link" v-b-modal.answers>
                    <b>Ver historial</b>
                  </b-button>
                </div>
              </div>
              <div
                class="col-sm-12 mt-4 mb-0 text-center"
                v-show="canEdit != 1"
              >
                <div v-if="!loading">
                  <button type="submit" class="btn button-save">
                    <p class="p1">{{ buttonSave }}</p>
                  </button>
                </div>
                <div v-else-if="loading" class="spinner-border" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
              </div>
            </form>
          </b-card-body>
        </b-card>
      </div>
      <!-- Modal de aviso que la respuesta no ha sido diligenciada -->
      <b-modal
        ref="bv-modal-aviso"
        hide-footer
        centered
        title="Atención al mensaje:"
        no-close-on-backdrop
      >
        <div class="d-block text-center">
          <h3>
            Diligencia la respuesta al derecho de Petición antes de enviar
          </h3>
        </div>
      </b-modal>
      <small v-show="error.flag" class="alert-danger">{{
        error.message
      }}</small>
      <div>
        <b-modal
          ref="my-modal"
          hide-footer
          centered
          title="Atención al mensaje:"
          no-close-on-backdrop
          @hidden="hideModal"
        >
          <div class="d-block text-center">
            <h3>{{ this.msjModal }}</h3>
          </div>
          <b-button
            class="mt-3"
            variant="outline-danger"
            block
            @click="hideModal"
          >
            Cerrar
          </b-button>
        </b-modal>

        <!-- Modal confirmando si desea reemplazar el borrador anterior -->

        <b-modal ref="confirmation-draft-modal" hide-footer centered title="Reemplazar Borrador">
          <div class="my-5 d-block text-center">
            <h3>¿Deseas sobrescribir el borrador anterior?</h3>
          </div>
            <div class="d-flex justify-content-around">
            <b-button
              class="mt-3 p-3 col-4 btn btn-danger"
              block
              @click="hideModal2()"
              >Cancelar</b-button
            >
            <b-button
              class="mt-3 p-3 col-4 btn"
              block
              @click="setDraftConfirmation()"
              >Reemplazar</b-button
            >
          </div>
        </b-modal>

        <b-modal
          id="answers"
          title="Historial de respuestas enviadas del derecho de petición"
          size="xl"
        >
          <table
            class="
              table
              table-bordered
              table-striped
              table-hover
              table-sm
              table-responsive
            "
          >
            <thead>
              <tr class="p1">
                <th class="text-center">id</th>
                <th class="text-center">No.</th>
                <th class="text-center">Fecha envio</th>
                <th class="text-center">Tipo envío de la respuesta</th>
                <th class="text-center">Tipo de respuesta</th>
                <th class="text-center">Mensaje</th>
                <th class="text-center">Descripcion</th>
                <th class="text-center">Respuesta</th>
                <th class="text-center">Evidencia de envio</th>
              </tr>
            </thead>
            <tbody v-for="(row, index) in this.respuestas" :key="index">
              <tr>
                <th class="text-center">{{ row.id }}</th>
                <td class="text-center">{{ index + 1 }}</td>
                <td>
                  <p class="p1">{{ row.created_at.substring(0, 10) }}</p>
                </td>
                <td>{{ row.typeShipping == 1 ? "Física" : "Correo" }}</td>
                <td>{{ row.type == "final" ? "Final" : "Provisional" }}</td>
                <td>{{ row.message }}</td>
                <td>
                  {{ row.recipient }}
                  <div
                    v-if="
                      row.typeShipping == 1 &&
                      (row.addressShipping == null ||
                        row.guide == null ||
                        row.business == null)
                    "
                  >
                    <b-button
                      @click="
                        $bvModal.show('modal-physical-response' + index),
                          checkPhisicalData(row)
                      "
                      >Agregar Datos</b-button
                    >

                    <!-- Modal en caso que sea necesario agragar los datos de envio Fisico -->

                    <b-modal
                      v-b-modal.modal-sm
                      :id="'modal-physical-response' + index"
                      ref="modal"
                      title="Agrega los datos incompletos"
                      @show="cleanDataModal"
                      @hidden="cleanDataModal"
                      @ok="savePhysicalResponse(row.id)"
                    >
                      <form
                        ref="form"
                        @submit.stop.prevent="savePhysicalResponse(row.id)"
                      >
                        <b-form-group
                          label="Dirección"
                          label-for="address"
                          invalid-feedback="Ingresa la dirección"
                        >
                          <b-form-input
                            id="address"
                            v-model="addressShipping"
                            required
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                          label="N° de Guia"
                          label-for="guide"
                          invalid-feedback="Ingresa el numero de guia"
                        >
                          <b-form-input
                            id="guide"
                            v-model="guide"
                            required
                          ></b-form-input>
                        </b-form-group>
                        <b-form-group
                          label="Transportadora"
                          label-for="business"
                          invalid-feedback="Ingresa el nombre de la transportadora"
                        >
                          <b-form-input
                            id="business"
                            v-model="business"
                            required
                          ></b-form-input>
                        </b-form-group>
                      </form>
                    </b-modal>
                  </div>
                  <div v-else>
                    <p>{{ row.addressShipping }}</p>
                    <p>{{ row.guide }}</p>
                    <p>{{ row.business }}</p>
                  </div>
                </td>
                <td>
                  <div class="td4 btn" style="background-color: #1c3a4e">
                    <a
                      :href="serverPath + '/PrAnswerLetterExport/' + row.id"
                      download
                      target="_blank"
                    >
                      <u style="color: white; text-decoration: none"
                        >Descagar PDF</u
                      >
                    </a>
                  </div>
                </td>
                <td>
                  <div style="width:25%, padding:2%">
                    <div
                      v-for="evidence in row.evidences"
                      :key="evidence.evidence_id"
                    >
                      <a
                        :href="serverPath + '/' + evidence.evidence_path"
                        download
                        style="font-size: 12px"
                        target="_blank"
                      >
                        <u
                          style="color:gray;text-decoration:none,padding:0 5px"
                          >{{ evidence.evidence_name }}</u
                        >
                      </a>
                      <a style="margin: 0 10px">
                        <img
                          class="can"
                          @click="deleteTemporalEvidence(evidence.evidence_id)"
                          src="@/assets/images/icons/trash.svg"
                        />
                      </a>
                    </div>
                  </div>
                  <div class="file-upload-img">
                    <input
                      type="file"
                      style="font-size: 10px"
                      :id="'fileDocuRT' + row.id"
                      @change="uploadfileTemporalRP(row.id)"
                      multiple
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "Response",
  components: {},
  props: {
    editorData: {
      type: String,
    },
  },
  data() {
    return {
      message: '',
      draftConfirmation: 0,
      buttonSave: "Enviar Respuesta",
      typeValidate: true,
      finalAnswer: false,
      finalButton: false,
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },

      showResponse: "",

      type: "",
      body: "",
      para: "",
      filesAnswer: [],
      typeShipping: "correo",
      withCopy: "no",
      addressShipping: "",
      guide: "",
      business: "",

      msjModal: "",
      flagPath: false,

      nameFile: "",
      show: true,

      society: "",
      opcionSocieties: [],

      canEdit: "",
      disabled: false,
      respuestas: [],
    };
  },
  beforeMount() {

    this.actGetAnswers(this.$route.params.id).then(() => {
      this.checkTemporalEvidence();
    });

    this.canEdit = "";
    this.setDraft(this.$route.params.id);
    this.setPreviusDraft();
    this.actGetInfoRP(this.$route.params.id).then(() => {
      this.setInfoRPl(this.infoRP.data);
      this.actSetSignatureBP(this.infoRP.data.business_partner_id);
      if (this.infoRPl.status == "closing" || this.infoRPl.status == "closed") {
        this.canEdit = 1;
      }
    });

    this.actGetfiles(this.$route.params.id);

    this.actGetSocieties().then(() => {
      this.societies.data.forEach((society) => {
        this.opcionSocieties.push({
          value: society.id,
          text: society.name,
        });
      });
    });
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", ["societies"]),
    ...mapState("modRightPetition", [
      "infoRP",
      "files",
      "stateProcess",
      "infoRPl",
      "linkProccess",
      "headerLetter",
      "footerLetter",
      "loading",
      "answers",
      "bpSignature",
      "draft"
    ]),
  },
  methods: {
    ...mapActions("modRightPetition", [
      "actGetInfoRP",
      "actGetfiles",
      "actSendResponse",
      "actDeleteFileRes",
      "actUploadFileRes",
      "actGetAnswers",
      "actGetEvidencesRP",
      "actSaveEvidenceRP",
      "actDeleteFileTemporalEvidence",
      "actSetSignatureBP",
      "actSaveDataPhisicalResponse",
      "setDraft",
    ]),

    ...mapActions("modRequest", ["actGetSocieties"]),

    ...mapMutations("modRightPetition", [
      "setStateProcess",
      "setInfoRPl",
      "setLinkProccess",
      "setHeader",
      "setFooter",
    ]),

    setPreviusDraft(){
      if(this.draft !== ""){
        this.editorData = this.draft
      }else if(this.draft === null){
        this.editorData = ''
      }
    },

    validateDraft() {
      if (this.type === "borrador") {
        this.typeValidate = false;
        this.buttonSave = "Guardar Borrador";
      } else {
        this.typeValidate = true;
        this.buttonSave = "Enviar Respuesta";
      }
    },

    checkPhisicalData(answer) {
      this.addressShipping = answer.addressShipping;
      this.guide = answer.guide;
      this.business = answer.business;
    },

    cleanDataModal() {
      this.addressShipping = "";
      this.guide = "";
      this.business = "";
    },

    savePhysicalResponse(id) {
      const data = [];
      data[0] = id;
      data[1] = {
        addressShipping: this.addressShipping,
        guide: this.guide,
        business: this.business,
      };
      this.actSaveDataPhisicalResponse(data).then(() => {
        this.actGetAnswers(this.$route.params.id).then(() => {
          this.checkTemporalEvidence();
        });
      });
    },

    cleanData() {
      if (this.typeShipping === "correo") {
        this.para = "";
      } else {
        this.addressShipping = "";
        this.guide = "";
        this.business = "";
      }
    },
    checkTemporalEvidence() {
      if (this.answers.data) {
        this.respuestas = this.answers.data;
        const temporalResponse = this.respuestas[this.respuestas.length - 1];
        if (
          temporalResponse.typeShipping === 1 &&
          (temporalResponse.evidences.length === 0 ||
          temporalResponse.addressShipping == null ||
          temporalResponse.guide == null ||
          temporalResponse.business == null)
        ) {
          this.finalAnswer = true;
        }else if (
          temporalResponse.typeShipping === 0 && 
          temporalResponse.evidences.length === 0
        ){
          this.finalAnswer = true;
        } else {
          this.finalAnswer = false;
        }
      }
    },

    setDraftConfirmation(){
      this.draftConfirmation = 1
      this.saveResponse()
      this.hideModal2()
    },

    changeLinkOfSignature(){
      this.message = ""
      let array = this.editorData.split('"')
      for (var i = 0; i < array.length; i++){
          if(array[i].includes("http")){
            if(this.infoRPl.business_partner_id !== null){
              array[i] = `firmaPdf.${this.bpSignature.signature}`
            }else if (this.infoRPl.business_partner_id == null){
              array[i] = `firmaPdf.${this.user.signature}`
            }
        }
      }
      if(array[1]){
        for (var x = 0; x < array.length; x++){
         this.message += (array[x] + '"')
        }
        this.message = this.message.substr(0, this.message.lastIndexOf('"'))
      }else{
        this.message = array[0]
      }
      this.response()
    },

    saveResponse() { 
      if (this.editorData === "") {
        this.$refs["bv-modal-aviso"].show();
        return;
      }
      if (this.type === 'borrador' && this.draft !== '' && this.draftConfirmation == 0) {
        this.$refs["confirmation-draft-modal"].show();
        return;
      }
      if(this.type !== 'borrador'){
          this.changeLinkOfSignature()
        return
      }else{
        this.response()
        return
      }
      
    },

    response(){
      let data = [];
      data[0] = this.$route.params.id;
      data[1] = {
        type: this.type,
        message: this.body,
        files: this.filesAnswer,
        recipient: this.para,
        society_id: this.society,
        letter: (this.type == 'borrador'? this.editorData:this.message),
        typeShipping: this.typeShipping == "fisica" ? 1 : 0,
        withCopy: this.withCopy == "si" ? 1 : 0,
        addressShipping: this.addressShipping,
        guide: this.guide,
        business: this.business,
      };

      //alert(JSON.stringify(data));
      this.actSendResponse(data)
        .then(() => {
          this.actGetInfoRP(this.$route.params.id).then(() => {
            this.setInfoRPl(this.infoRP.data);
            this.setDraft(this.$route.params.id);
            switch (this.type) {
              case 'final':
                this.setStateProcess(3);
                this.setLinkProccess(3);
                this.showModal(
                    "Se envio correctamente la respuesta Final", 0
                  );
                break;
              case 'provisional':
                this.showModal(
                  "Se envio correctamente la respuesta provisional", 0
                );
                break;
              case 'borrador':
                this.showModal(
                  "El borrador ha sido guardado correctamente", 0)
            }
          });
        })
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "Ocurrio un error al actualizar los datos: " + response;
        });
    },
    
    deleteTemporalEvidence(id) {
      this.actDeleteFileTemporalEvidence(id).then(() => {
        this.actGetAnswers(this.$route.params.id).then(() => {
          this.checkTemporalEvidence();
        });
      });
    },
    formatDateShow(date) {
      var d = new Date(date);
      var datestring =
        d.getDate() +
        " " +
        this.monthNames[d.getMonth() + 1] +
        " " +
        d.getFullYear();
      return datestring;
    },

    fileSelected() {
      const dato = document.querySelector("#fileDocu");
      this.nameFile = dato.files[0].name;
      //alert(this.header_img)
    },

    setImages() {
      this.societies.data.forEach((r) => {
        if (r.id == this.society) {
          this.setHeader(r.header_img);
          this.setFooter(r.footer_img);
        }
      });
    },

    uploadfile() {
      var formData = new FormData();
      var data = [];
      const file = document.querySelector("#fileDocu");

      formData.append("file", file.files[0]);
      formData.append("email", this.infoRPl.forum.participants[0].email);

      data[0] = this.$route.params.id;
      data[1] = formData;

      this.actUploadFileRes(data).then(() => {
        this.actGetfiles(this.$route.params.id);
      });
    },

    deleteFileRes(idRes, idFile) {
      this.$bvModal
        .msgBoxConfirm("¿Desea borrar este archivo del servidor?", {
          title: "Atención al mensaje:",
          size: "sm",
          buttonSize: "lg",
          okVariant: "danger",
          okTitle: "CONTINUAR",
          cancelTitle: "CANCELAR",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            var data = [];
            data[0] = idFile;
            data[1] = {
              participant_id: idRes,
            };

            this.actDeleteFileRes(data).then(() => {
              this.actGetfiles(this.$route.params.id);
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    uploadfileTemporalRP(row_id) {
      var data = [];
      var id = "#fileDocuRT" + row_id;
      var formData = new FormData();
      const dato = document.querySelector(id);
      formData.append("files[]", dato.files[0]);
      formData.append("answer_id", row_id);

      data[0] = this.$route.params.id;
      data[1] = formData;

      this.actSaveEvidenceRP(data).then(() => {
        this.actGetAnswers(this.$route.params.id).then(() => {
          this.checkTemporalEvidence();
        });
      });

      dato.value = "";

      //   this.actGetAnswers(this.$route.params.id).then(() =>{
      //   if(this.answers.data){
      //       this.respuestas = this.answers.data;
      //       this.checkTemporalEvidence()
      //     }
      // });
    },

    showModal(msj, flag) {
      this.msjModal = msj;
      this.flagPath = flag;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal",'confirmation-draft-modal'].hide();
      if (this.flagPath == 1) {
        this.$router.push({ path: "/listRP" });
      }
      this.$router.go(0);
    },
    hideModal2() {
      this.$refs['confirmation-draft-modal'].hide();
    },
  },
};
</script>

<style lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.button-save {
  .p1 {
    color: white !important;
    margin: 5px;
  }
}
.button-save {
  background-color: #1c6776 !important;
}
.button-save:hover {
  background-color: #154e5a !important;
}
.can {
  cursor: pointer;
  padding: 5px;
  border-radius: 2px;
}
.can:hover {
  background-color: #ccc;
}
.can img {
  height: 10px;
}
.page-rightpetition {
  .title-1 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }
  .cont-rightpetition-text {
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 20px;
        font-weight: bold;
        color: #1c3a4e;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-rightpetition {
      .form-group-req {
        input[type="text"] {
          height: 32px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }
    }
  }

  .button1 {
    //background: #E9ECEE;
    color: #1c3a4e;
    //border-radius: 50px;
    height: 25px;
    font-size: 16px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
  }
  .button2 {
    background: #1c3a4e;
    color: #ffffff;
    border-radius: 50px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .button3 {
    border: none;
    background-color: inherit;
    padding: 5px 10px;
    font-size: 11px;
    cursor: pointer;
    display: inline-block;
    text-decoration: underline;
  }
  .button4 {
    background: #99a6af;
    color: #ffffff;
    border-radius: 8px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#99a6af, 5);
    }
  }
  .button2:hover {
    background: #eee;
  }
  .default {
    color: black;
  }
  .tr1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
    padding-left: 5%;
  }
  .td1 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
  }
  .td2 {
    background: #ffffff;
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
    width: 95px;
    text-align: center;
  }
  .td3 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
  }
  .td4 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
  }
  .td5 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;
  }
  .tabla1 {
    border-radius: 5px;
    border: 3px solid #1c3a4e;
    border-color: #1c3a4e;
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 470px;
  }
  .p1 {
    color: #1c3a4e;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .img1 {
    width: 18px;
    height: 18px;
    left: 100%;
    top: 100%;
    float: center;
  }
  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }
  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #779b49;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #779b49;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
  .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 1px 2px;
    cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
  .scrollable {
    overflow: hidden;
    overflow-y: scroll;
    height: calc(30vh - 20px);
  }

  .file-upload-img {
    width: 120px;
    height: 80px;
    //border-style: dotted;
    text-align: center;
    display: flex;
    align-items: center;
  }
  .file-upload-img img {
    width: 100%;
    height: 100%;
  }
  input[type="file"] {
    opacity: 0;
    filter: alpha(opacity=0);
    display: block;
    width: 360px;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .td4 {
    background: #1c3a4e;
    color: #ffffff;
    font-family: "Open Sans";
    //font-weight: bold;
    font-size: 12px;
    line-height: 25px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
    text-align: left;
  }

  .leftImg1 {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  .btn-table,
  .btn-table:link,
  .btn-table:hover {
    color: white;
    text-decoration: none;
    font-size: 15px;
  }
}
</style>